import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import InstructorForm from './InstructorForm';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './store/actions';
import * as validatorActions from '../../components/validator/store/actions';
import { Button, Tab, Tabs, Grid, DialogTitle, DialogContent, DialogActions, Dialog, Typography } from '@material-ui/core';
import DetailCalendar from '../../components/DetailCalendar';
import TabPanelButtons from '../../components/TabPanelButtons';
import InstructorQualifications from './InstructorQualificiations';
import PageHeader from 'main/components/PageHeader';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '144px'
        }
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
        minWidth: '80%',
        maxWidth: '80%'
    },
});

class Instructor extends Component {
    state = {
        current_tab: 0,
        instructor_id: 0,
        view_type: '',
        tabValue: 0,
        deleteDialogActive: false
    }

    constructor(props) {
        super(props);

        const instructor_id = this.props.match.params.instructor_id;
        const view_type = this.props.match.params.view_type;

        this.state = {
            ...this.state,
            instructor_id: instructor_id,
            view_type: view_type,
        }

        this.props.updateInstructorLoaded(false);
        this.props.getInstructorData(instructor_id);


        const validationList = [
            {
                field_name: 'FirstName', functionName: ['checkRequiredFilled']
            },
            {
                field_name: 'LastName', functionName: ['checkRequiredFilled']
            },
            {
                field_name: 'Email', functionName: ['checkEmailUnique', 'checkEmailValid'], id: instructor_id, component: 'instructor'
            },
            {
                field_name: 'Password', functionName: ['checkFieldLength'], chars: 4,
            },
            {
                field_name: 'PasswordConfirm', functionName: ['checkFieldLength'], chars: 4,
            },
        ]

        this.props.startValidator(validationList)
    }

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        })
    }

    handleChangeIndex = index => {
        this.setState({ value: index });
    };

    handleSubmit = () => {
        // const instructorQuals = this.props.qualifications.filter(q => q.active)
        switch (this.state.view_type) {
            case ("create"):
                {
                    this.props.saveInstructor(this.props.currentInstructor, [], this.props.qualifications, this.props.auth.user.data.auth_id)
                    this.props.history.push('/instructor/list')

                    break;
                }

            case ("edit"):
                // test
                {
                    this.props.saveInstructor(this.props.currentInstructor, [], this.props.qualifications, this.props.auth.user.data.auth_id)
                    this.props.history.push('/instructor/list');
                    break;
                }

            default:
                {

                }
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ deleteDialogActive: true })
    }

    handleDelete = () => {
        switch (this.state.view_type) {
            case ("edit"):
                {
                    this.props.deleteInstructor(this.props.currentInstructor.instructor_id);
                    this.props.history.push('/instructor/list');
                    break;
                }

            default:
                {

                }

        }
    }

    deactivateInstructorAuth = () => {
        this.props.deactivateInstructorAuth(this.props.currentInstructor.related_auth_id, this.props.currentInstructor.instructor_id);
        this.props.history.push('/instructor/list');
    }

    handleCourseSearchChange = (e) => {
        this.setState({
            courseSearch: e.target.value
        })
    }

    handleModuleSearchChange = (e) => {
        this.setState({
            moduleSearch: e.target.value
        })
    }

    getPageContent = (current_tab, view_type) => {
        const { classes, theme, currentInstructor, allCourses, allModules, allCompanies, currentInstructorCourseList,
            currentInstructorModuleList, events, dayEvents } = this.props;

        switch (current_tab) {
            case (0):
                {
                    return (
                        <InstructorForm
                            view_type={view_type}
                        />
                    )
                }
            // case (1):
            //     {
            //         return (
            //             view_type === 'detail' ?
            //                 <Grid container spacing={24}>

            //                 </Grid>
            //                 :
            //                 <Grid container spacing={24}>
            //                 </Grid>
            //         )
            //     }
            case (1):
                {
                    return (
                        // <InstructorSchedule
                        //     events={events}
                        //     dayEvents={dayEvents}
                        //     instructor={currentInstructor}
                        // />
                        <DetailCalendar
                            object_id={currentInstructor.instructor_id}
                            events={events}
                            dayEvents={dayEvents}
                            getSchedule={this.props.getEvents}
                            getDayEvents={this.props.getDayEvents}
                        />
                    )
                }
            case (2):
                {
                    return (
                        <InstructorQualifications
                            companies={this.props.currentInstructorCompanyList}
                            instructor={this.props.currentInstructor}
                            view_type={this.state.view_type}
                        />
                    )
                }
            default:
                {
                    return <React.Fragment>Error: No tab found.</React.Fragment>
                }
        }
    }

    getDeleteDialog = (active, instructor) => {

        const role_info = (prop) => {
            if (prop) {
                return (
                    <div>
                        <Typography>{instructor.FirstName + ' ' + instructor.LastName} has the following roles: </Typography>
                        {this.props.roles.map((role, i) => {
                            return (
                                <div key={i}> <b>{i + 1}</b>: {role.RoleName} </div>
                            )
                        })}
                    </div>
                )
            }
        }

        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ deleteDialogActive: false })}
            >
                <DialogTitle>Confirm Delete {instructor.FirstName + ' ' + instructor.LastName}?</DialogTitle>
                <DialogContent>
                    {role_info(this.props.roles.length > 1)}
                    <div>Deactivating User will not delete roles or data associated with the user, but it will hide them.</div>
                    <div>Deleting Instructor will remove all relationships with courses, companies, and well as their qualifications.</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.deactivateInstructorAuth()} color="primary">
                        Deactivate User
                    </Button>
                    <Button onClick={() => this.handleDelete()} color="primary">
                        Delete Instructor
                    </Button>
                    <Button onClick={() => this.setState({ deleteDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    disableSave = () => {
        const { validator } = this.props;
        const { view_type } = this.state

        switch (view_type) {
            case ("edit"): {
                return (
                    validator.map(v => v.error)
                        .includes(true)
                )
            }
            case ('create'): {
                return !(
                    validator.every(v => v.error === false)
                )
            }
        }
    };

    render() {
        const { classes, currentInstructor, isInstructorLoaded } = this.props;
        const { current_tab, view_type } = this.state;
        const delete_dialog = this.getDeleteDialog(this.state.deleteDialogActive, this.props.currentInstructor);

        if (!isInstructorLoaded) {
            return <div>loading</div>
        }

        let page_content = <React.Fragment>Loading...</React.Fragment>;
        if (isInstructorLoaded) {
            page_content = this.getPageContent(current_tab, view_type);
        }

        const deleteTooltipContent =
            <React.Fragment>
                <h5>This Instructor teaching the upcoming courses:</h5>
                {this.props.upcomingCourses.map(c => {
                    return (
                        <div key={c.company_calendar_course_id}>
                            {c.CourseName}: {c.StartDate} - {c.EndDate}
                        </div>
                    )
                })}
            </React.Fragment>

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <PageHeader
                        component_name = {currentInstructor.FirstName + " " + currentInstructor.LastName}
                        component_type = {"instructor"}
                        view_type      = {view_type}
                    />
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%' }}>
                        <Grid container>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                                scrollable={true}
                            >
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Detail"
                                />
                                {/* <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Relation"
                                /> */}
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Schedule"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Qualifications"
                                    disabled={view_type === 'create'}
                                />
                            </Tabs>
                            <TabPanelButtons
                                component_name = {"instructor"}
                                view_type      = {view_type}
                                button_list    = {[
                                    {
                                        display:  "Save",
                                        type:     "update",
                                        onClick:  this.handleSubmit,
                                        disabled: this.disableSave(),
                                    },
                                    {
                                        type:     "delete",
                                        onClick:  this.handleDeleteDialogOpen,
                                        disabled: !this.props.deleteAllowed,
                                        tooltip:  { active: !this.props.deleteAllowed, content: deleteTooltipContent },

                                    },
                                    {
                                        type:    "back",
                                        onClick: this.props.history.goBack,
                                    }
                                ]}
                            />
                        </Grid>
                    </div>
                }
                content={
                    <React.Fragment>
                        <div className="p-24">
                            {delete_dialog}
                            {page_content}
                        </div>
                    </React.Fragment>
                }
            />
        )
    }
}



function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getInstructor: Actions.getInstructor,
        updateInstructorLoaded: Actions.updateInstructorLoaded,
        getInstructorData: Actions.getInstructorData,
        updateInstructorForm: Actions.updateInstructorForm,
        deleteInstructor: Actions.deleteInstructor,
        saveInstructor: Actions.saveInstructor,
        startValidator: validatorActions.startValidator,
        getEvents: Actions.getInstructorSchedule,
        getDayEvents: Actions.getDayEvents,
        deactivateInstructorAuth: Actions.deactivateInstructorAuth
    }, dispatch);
}

function mapStateToProps({ instructorApp, validator, auth }) {
    return {
        currentInstructor: instructorApp.instructors.currentInstructor,
        allCourses: instructorApp.instructors.allCourses,
        allModules: instructorApp.instructors.allModules,
        allCompanies: instructorApp.instructors.allCompanies,
        allLessons: instructorApp.instructors.allLessons,
        isInstructorLoaded: instructorApp.instructors.isInstructorLoaded,
        events: instructorApp.instructors.events,
        dayEvents: instructorApp.instructors.dayEvents,
        roles: instructorApp.instructors.roles,
        validator: validator.list,
        qualifications: instructorApp.instructors.qualifications,
        currentInstructorCompanyList: instructorApp.instructors.currentInstructorCompanyList,
        upcomingCourses: instructorApp.instructors.upcomingCourses,
        deleteAllowed: instructorApp.instructors.deleteAllowed,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Instructor)));



// WEBPACK FOOTER //
// src/main/content/instructor/Instructor.js